import cloneDeep from 'clone-deep'
import {
  mergeOriginatorInformationConfig,
  originatorFieldKeys,
  OriginatorInformationConfig,
} from 'pages/LoanApplication/SignApplication/originatorInformation.constants'
import { useState } from 'react'
import { Modal } from 'stories/components'
import { RenderInput } from 'utils/RenderInput'

type Props = {
  value: OriginatorInformationConfig | undefined
  onClose: () => void
  onSave: (value: OriginatorInformationConfig) => void
}

export const OriginatorConfigModal = ({ value, onClose, onSave }: Props) => {
  const [draft, setDraft] = useState<OriginatorInformationConfig>(() => mergeOriginatorInformationConfig(value))

  const onChangeTitle = (title: string) => {
    setDraft({ ...draft, title })
  }

  const onChangeField = (key: typeof originatorFieldKeys[number], subKey: 'title' | 'visible', next: any) => {
    const temp = cloneDeep(draft)
    temp.fields[key] = { ...temp.fields[key], [subKey]: next }
    setDraft(temp)
  }

  return (
    <Modal
      isOpen
      title="Loan Originator Information"
      titleOkay="Save"
      onClose={onClose}
      onOk={() => {
        onSave(draft)
        return true
      }}
    >
      <div className="w-[min(640px,90vw)] max-h-[70vh] overflow-y-auto space-y-4 pr-1">
        <RenderInput
          input={{
            inputType: 'text',
            title: 'Section Title',
            value: draft.title,
          }}
          Key="title"
          onChange={(_key: string, v: string) => onChangeTitle(v)}
        />
        <div className="text-section">Fields</div>
        {originatorFieldKeys.map((key) => (
          <div key={key} className="grid grid-cols-1 sm:grid-cols-[1fr_auto] gap-2 items-end border-b pb-3">
            <RenderInput
              input={{
                inputType: 'text',
                title: 'Label',
                value: draft.fields[key].title,
              }}
              Key={`${key}.title`}
              onChange={(_k: string, v: string) => onChangeField(key, 'title', v)}
            />
            <RenderInput
              input={{
                inputType: 'ToggleButton',
                title: 'Visible',
                value: draft.fields[key].visible,
              }}
              Key={`${key}.visible`}
              onChange={(_k: string, v: boolean) => onChangeField(key, 'visible', v)}
            />
          </div>
        ))}
      </div>
    </Modal>
  )
}
